import { render, staticRenderFns } from "./xskj1-1.vue?vue&type=template&id=33270c16&scoped=true&"
import script from "./xskj1-1.vue?vue&type=script&lang=js&"
export * from "./xskj1-1.vue?vue&type=script&lang=js&"
import style0 from "./xskj1-1.vue?vue&type=style&index=0&id=33270c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33270c16",
  null
  
)

export default component.exports